import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_PDPM_FEATURE_TOGGLE_REQUEST,
  GET_PDPM_FEATURE_TOGGLE_SUCCESS,
  GET_PDPM_FEATURE_TOGGLE_FAILURE,
  GET_PDPM_FEATURE_TOGGLE_LOADING,
} = therapyPlanningAction;

function* getPdpmFeatureToggle(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PDPM_FEATURE_TOGGLE_LOADING });
    const response = yield call(therapyPlanningService.getPdpmFeatureToggle, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PDPM_FEATURE_TOGGLE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PDPM_FEATURE_TOGGLE_FAILURE, payload: error });
  }
}

function* getPdpmFeatureToggleSaga() {
  yield takeEvery(GET_PDPM_FEATURE_TOGGLE_REQUEST, getPdpmFeatureToggle);
}

export default getPdpmFeatureToggleSaga;